// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"78206b48","89":"e1fa902a","453":"a366d363"}[chunkId] + ".chunk.js";
};